// extracted by mini-css-extract-plugin
export default {"mono":"PromptEditor_mono__ETF11","stickyBar":"PromptEditor_stickyBar__V74JM","outputBlock":"PromptEditor_outputBlock__5+jX5"};